const companyLogoPath = "assets/workMedia/";

const work = [
	{
		company: "Octopus Energy",
		location: "London, United Kingdom",
		type: "Internship",
		duration: "3 Months",
		role: "Backend Developer",
		startDate: "June 2023",
		endDate: "September 2023",
		roleDesc: [
			"Extensively planned a Django project and created a proposal outlining the justification and components of the project.",
			"Incrementally added features following the proposal, using unit and functional testing to validate new components.",
			"Used Git version control to ensure our features were compatible with the existing codebase.",
			"Proactively organised meetings with end users to get additional guidance and ensure that our project was helpful.",
			"Presented my project to the CTO of Octopus Energy, responding perceptively to questions about implementation details.",
		],
		companyLogo: companyLogoPath + "octopus.png",
	},
];

export default work;
